"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keepKeys = exports.removeKeys = exports.setProperties = exports.getKeys = exports.executeArray = exports.executeFunctionAll = exports.executeFunction = exports.execute = exports.exec = exports.promiseAll = exports.promiseAny = exports.BasPromiseResult = exports.clampDegrees = exports.clamp = exports.polarToCartesian = exports.hexToMacAddress = exports.stringToInt = exports.objectToHash = exports.objectToArray = exports.toISO8601Extended = exports.durationToString = exports.secondsToString = exports.temperatureToRgb = exports.hsvToRgb = exports.rgbToHsv = exports.hslToRgb = exports.rgbToHsl = exports.isValidIp = exports.isValidHostname = exports.isMACAddress = exports.couldBeMACAddress = exports.isEqualPartialArray = exports.isEqualArrayUn = exports.isEqualArray = exports.isNEArray = exports.isEqualPartialObject = exports.isEqualObject = exports.compareObjects = exports.safeHasOwnProperty = exports.isNEObject = exports.isObject = exports.isInteger = exports.isPNumber = exports.isVNumber = exports.isNEString = exports.isUndefined = exports.isNumber = exports.isString = exports.isFunction = exports.isBool = void 0;
exports.BasVersion = exports.removeFromArray = exports.filter = exports.uuidv4 = exports.getWeekNumber = exports.dateFormat = exports.hasValidKnownScheme = exports.getPrecision = exports.numberToString = exports.eNumberToFixedLength = exports.charIsNumber = exports.trimNumber = exports.toFixedRounded = exports.round = exports.isWithinLoopingBounds = exports.randomString = exports.searchCharacters = exports.stripStart = exports.addToString = exports.endsWith = exports.startsWith = exports.timeout = exports.distanceSquared = exports.stripTimezoneFromIso8601 = exports.parseIso8601 = exports.parseInteger = exports.setDOMListener = exports.setEventListener = exports.compareRoundedValue = exports.getCorrectedValue = exports.getTemperatureFraction = exports.formatTemperature = exports.padLeft = exports.switchObjectKeyValue = exports.mergeCounterObjects = exports.mergeObjectsDeep = exports.mergeObjects = exports.copyObject = exports.copyObjectShallow = void 0;
var IP_REGEX = /^\b(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\b$/;
var MAC_REGEX = /^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/;
var HOSTNAME_REGEX = /^([a-zA-Z0-9._-]+)(:([0-9]+))?(:([0-9]+))?$/;
var DATE_FORMAT_TOKEN_REGEX = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|W{1,2}|[LlopSZ]|"[^"]*"|'[^']*'/g;
var DATE_FORMAT_TIMEZONE_REGEX = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
var DATE_FORMAT_TIMEZONE_CLIP_REGEX = /[^-+\dA-Z]/g;
var DATE_FORMAT_DAY_NAMES = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];
var DATE_FORMAT_MONTH_NAMES = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
var DATE_FORMAT_TIME_NAMES = ["a", "p", "am", "pm", "A", "P", "AM", "PM"];
var MAC_ADDRESS_LENGTH = 17;
var ENTRIES = "abcdefghijklmnopqrstuvwxyz" +
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ" +
    "0123456789" +
    ".,?!:;+-_=(){}[]*&^%$#@";
var ENTRIES_LENGTH = ENTRIES.length;
// #region Checks
function isBool(value) {
    return typeof value === "boolean";
}
exports.isBool = isBool;
function isFunction(value) {
    return typeof value === "function";
}
exports.isFunction = isFunction;
function isString(value) {
    return typeof value === "string";
}
exports.isString = isString;
function isNumber(value) {
    return typeof value === "number";
}
exports.isNumber = isNumber;
function isUndefined(value) {
    return typeof value === "undefined";
}
exports.isUndefined = isUndefined;
function isNEString(value) {
    return isString(value) && value.length > 0;
}
exports.isNEString = isNEString;
function isVNumber(value) {
    return isNumber(value) && isFinite(value);
}
exports.isVNumber = isVNumber;
function isPNumber(value, allowZero) {
    return allowZero === true
        ? isNumber(value) && value >= 0
        : isNumber(value) && value > 0;
}
exports.isPNumber = isPNumber;
function isInteger(value) {
    return isNumber(value) && value % 1 === 0;
}
exports.isInteger = isInteger;
/**
 * Check for not null object
 */
function isObject(value) {
    return typeof value === "object" && value !== null;
}
exports.isObject = isObject;
/**
 * Check for not null object and has keys
 */
function isNEObject(value) {
    return isObject(value) && Object.keys(value).length > 0;
}
exports.isNEObject = isNEObject;
/**
 * Safe "hasOwnProperty" check
 */
function safeHasOwnProperty(object, key) {
    return isObject(object)
        ? Object.prototype.hasOwnProperty.call(object, key)
        : false;
}
exports.safeHasOwnProperty = safeHasOwnProperty;
/**
 * Shallow compares 2 Objects
 */
function compareObjects(obj1, obj2) {
    if (isObject(obj1) && isObject(obj2)) {
        var array1 = Object.keys(obj1);
        var array2 = Object.keys(obj2);
        if (Array.isArray(array1) &&
            Array.isArray(array2) &&
            array1.length === array2.length &&
            isEqualArrayUn(array1, array2)) {
            var length_1 = array1.length;
            for (var i = 0; i < length_1; i++) {
                if (obj1[array1[i]] !== obj2[array1[i]])
                    return false;
            }
            return true;
        }
        return false;
    }
    return obj1 === obj2;
}
exports.compareObjects = compareObjects;
/**
 * Check for equality.
 * Deep check based on primitives.
 * Functions and symbols are checked with ===.
 *
 * Warning: this function will result in an endless loop
 * when object has references to itself
 */
function isEqualObject(obj1, obj2) {
    if (isObject(obj1) && isObject(obj2)) {
        var k1 = Object.keys(obj1);
        var k2 = Object.keys(obj2);
        if (!isEqualArrayUn(k1, k2))
            return false;
        var length_2 = k1.length;
        for (var i = 0; i < length_2; i++) {
            var key = k1[i];
            var p1 = obj1[key];
            var p2 = obj2[key];
            var p1Type = typeof p1;
            var p2Type = typeof p2;
            if (p1Type === p2Type) {
                if (p1Type === "object") {
                    if (!isEqualObject(p1, p2))
                        return false;
                }
                else {
                    if (p1 !== p2)
                        return false;
                }
            }
            else {
                return false;
            }
        }
        return true;
    }
    return obj1 === obj2 && (typeof obj1 === "object" || obj1 === undefined);
}
exports.isEqualObject = isEqualObject;
/**
 * Check for equality, partial object is allowed
 * to have a subset of the properties of the main object.
 * As long as the matching properties (and values) are the same,
 * result will be true.
 *
 * Warning: this function will result in an endless loop
 * when object has references to itself
 */
function isEqualPartialObject(main, partial) {
    if (isObject(main) && isObject(partial)) {
        var mKeys = Object.keys(main);
        var pKeys = Object.keys(partial);
        var length_3 = pKeys.length;
        if (length_3 === 0)
            return true;
        if (!isEqualPartialArray(mKeys, pKeys))
            return false;
        for (var i = 0; i < length_3; i++) {
            var pKey = pKeys[i];
            var mValue = main[pKey];
            var pValue = partial[pKey];
            var mType = typeof mValue;
            var pType = typeof pValue;
            if (mType === pType) {
                if (mType === "object") {
                    if (!isEqualPartialObject(mValue, pValue))
                        return false;
                }
                else {
                    if (mValue !== pValue)
                        return false;
                }
            }
            else {
                return false;
            }
        }
        return true;
    }
    return main === partial && (typeof main === "object" || main === undefined);
}
exports.isEqualPartialObject = isEqualPartialObject;
function isNEArray(value) {
    return Array.isArray(value) && value.length > 0;
}
exports.isNEArray = isNEArray;
/**
 * Checks 2 arrays for equality.
 * Same items in different order is false.
 * Shallow inspection.
 */
function isEqualArray(arr1, arr2) {
    if (Array.isArray(arr1) &&
        Array.isArray(arr2) &&
        arr1.length === arr2.length) {
        var length_4 = arr1.length;
        for (var i = 0; i < length_4; i++) {
            if (arr1[i] !== arr2[i])
                return false;
        }
        return true;
    }
    return false;
}
exports.isEqualArray = isEqualArray;
/**
 * Checks 2 arrays for equality.
 * Same items in different order is true.
 * Shallow inspection.
 */
function isEqualArrayUn(arr1, arr2) {
    if (Array.isArray(arr1) &&
        Array.isArray(arr2) &&
        arr1.length === arr2.length) {
        var length_5 = arr1.length;
        for (var i = 0; i < length_5; i++) {
            if (arr2.indexOf(arr1[i]) === -1)
                return false;
        }
        return true;
    }
    return false;
}
exports.isEqualArrayUn = isEqualArrayUn;
/**
 * Checks if partial array items are found in main array.
 * Same items in different order is true.
 * Duplicates in partials are not supported,
 * we don't take amount of duplicates into account.
 * However we do compare array length.
 * Shallow inspection.
 */
function isEqualPartialArray(main, partial) {
    if (Array.isArray(main) &&
        Array.isArray(partial) &&
        main.length >= partial.length) {
        var length_6 = partial.length;
        for (var i = 0; i < length_6; i++) {
            if (main.indexOf(partial[i]) === -1)
                return false;
        }
        return true;
    }
    return false;
}
exports.isEqualPartialArray = isEqualPartialArray;
/**
 * Only checks for a string of the correct length (17)
 */
function couldBeMACAddress(address) {
    return isString(address) && address.length === MAC_ADDRESS_LENGTH;
}
exports.couldBeMACAddress = couldBeMACAddress;
function isMACAddress(address) {
    return MAC_REGEX.test(address);
}
exports.isMACAddress = isMACAddress;
/**
 * Hostname can have 2 port specifiers
 */
function isValidHostname(hostname) {
    return isNEString(hostname) && !!hostname.match(HOSTNAME_REGEX);
}
exports.isValidHostname = isValidHostname;
function isValidIp(ip) {
    return isNEString(ip) && IP_REGEX.test(ip);
}
exports.isValidIp = isValidIp;
// #endregion
// #region Converter
/**
 * Converts an RGB color value to HSL. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes r, g, and b are contained in the set [0, 255] and
 * returns h, s, and l in the set [0, 1].
 */
function rgbToHsl(r, g, b) {
    var lr = r / 255;
    var lg = g / 255;
    var lb = b / 255;
    var max = Math.max(lr, lg, lb);
    var min = Math.min(lr, lg, lb);
    var h;
    var s;
    var l = (max + min) / 2;
    if (max === min) {
        // achromatic
        h = s = 0;
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case lr:
                h = (lg - lb) / d + (lg < lb ? 6 : 0);
                break;
            case lg:
                h = (lb - lr) / d + 2;
                break;
            case lb:
                h = (lr - lg) / d + 4;
                break;
            default:
                h = 0;
        }
        h /= 6;
    }
    return [h, s, l];
}
exports.rgbToHsl = rgbToHsl;
/**
 * Converts an HSL color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes h, s, and l are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 */
function hslToRgb(h, s, l) {
    var r, g, b;
    if (s === 0) {
        // achromatic
        r = g = b = l;
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    function hue2rgb(p, q, t) {
        var lt = t;
        if (lt < 0)
            lt += 1;
        if (lt > 1)
            lt -= 1;
        if (lt < 1 / 6)
            return p + (q - p) * 6 * lt;
        if (lt < 1 / 2)
            return q;
        if (lt < 2 / 3)
            return p + (q - p) * (2 / 3 - lt) * 6;
        return p;
    }
}
exports.hslToRgb = hslToRgb;
/**
 * Converts an RGB color value to HSV. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSV_color_space.
 * Assumes r, g, and b are contained in the set [0, 255] and
 * returns h, s, and v in the set [0, 1].
 */
function rgbToHsv(r, g, b) {
    var lr = r / 255;
    var lg = g / 255;
    var lb = b / 255;
    var max = Math.max(lr, lg, lb);
    var min = Math.min(lr, lg, lb);
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    var h;
    if (max === min) {
        // achromatic
        h = 0;
    }
    else {
        switch (max) {
            case lr:
                h = (lg - lb) / d + (lg < lb ? 6 : 0);
                break;
            case lg:
                h = (lb - lr) / d + 2;
                break;
            case lb:
                h = (lr - lg) / d + 4;
                break;
            default:
                h = 0;
        }
        h /= 6;
    }
    return [h, s, v];
}
exports.rgbToHsv = rgbToHsv;
/**
 * Converts an HSV color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSV_color_space.
 * Assumes h, s, and v are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 */
function hsvToRgb(h, s, v) {
    var r, g, b;
    var i = Math.floor(h * 6);
    var f = h * 6 - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    switch (i % 6) {
        case 0:
            r = v;
            g = t;
            b = p;
            break;
        case 1:
            r = q;
            g = v;
            b = p;
            break;
        case 2:
            r = p;
            g = v;
            b = t;
            break;
        case 3:
            r = p;
            g = q;
            b = v;
            break;
        case 4:
            r = t;
            g = p;
            b = v;
            break;
        case 5:
            r = v;
            g = p;
            b = q;
            break;
        default:
            r = 0;
            g = 0;
            b = 0;
    }
    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}
exports.hsvToRgb = hsvToRgb;
/**
 * Converts a color temperature value to RGB.
 * Assumes temperature is contained in the set [1000, 40000] and
 * returns r, g, and b in the set [0, 255].
 *
 * For reference
 * https://andi-siess.de/rgb-to-color-temperature/
 */
function temperatureToRgb(temperature) {
    var lTemperature = temperature / 100;
    var r, g, b;
    // Red
    if (lTemperature <= 66) {
        r = 255;
    }
    else {
        var tmpCalc = lTemperature - 60;
        tmpCalc = 329.698727446 * Math.pow(tmpCalc, -0.1332047592);
        r = clamp(tmpCalc, 0, 255);
    }
    // Green
    if (lTemperature <= 66) {
        var tmpCalc = lTemperature;
        tmpCalc = 99.4708025861 * Math.log(tmpCalc) - 161.1195681661;
        g = tmpCalc;
        if (g < 0)
            g = 0;
        if (g > 255)
            g = 255;
    }
    else {
        var tmpCalc = lTemperature - 60;
        tmpCalc = 288.1221695283 * Math.pow(tmpCalc, -0.0755148492);
        g = clamp(tmpCalc, 0, 255);
    }
    // Blue
    if (lTemperature >= 66) {
        b = 255;
    }
    else if (lTemperature <= 19) {
        b = 0;
    }
    else {
        var tmpCalc = lTemperature - 10;
        tmpCalc = 138.5177312231 * Math.log(tmpCalc) - 305.0447927307;
        b = clamp(tmpCalc, 0, 255);
    }
    return [Math.round(r), Math.round(g), Math.round(b)];
}
exports.temperatureToRgb = temperatureToRgb;
/**
 * Converts seconds into 00m 00s format
 * No leading zeros
 */
function secondsToString(seconds) {
    var time = "";
    if (seconds >= 60)
        time += Math.floor(seconds / 60) + "m ";
    time += (seconds % 60) + "s";
    return time;
}
exports.secondsToString = secondsToString;
/**
 * Convert a number of seconds in (h)h:mm:ss string
 * If hour is 0 then the result will be (m)m:ss
 */
function durationToString(duration) {
    var result = "";
    // Hours
    var hours = Math.floor(duration / 3600);
    if (hours > 0)
        result += hours + ":";
    var temp = duration % 3600;
    // Minutes
    result += padLeft(Math.floor(temp / 60), hours > 0 ? 2 : 1);
    // Seconds
    result += ":" + padLeft(temp % 60, 2);
    return result;
}
exports.durationToString = durationToString;
/**
 * Converts a given Date/time to an ISO 8601 Extended notation
 *
 * 2021-11-24T14:46:09.634Z => 2021-11-24T14:46:09+0000
 */
function toISO8601Extended(input) {
    var d = isObject(input) && isFunction(input.getUTCFullYear)
        ? input
        : new Date(input);
    return ("" +
        "".concat(d.getUTCFullYear()) +
        "-".concat(padLeft(d.getUTCMonth() + 1, 2, "0")) +
        "-".concat(padLeft(d.getUTCDate(), 2, "0")) +
        "T".concat(padLeft(d.getUTCHours(), 2, "0")) +
        ":".concat(padLeft(d.getUTCMinutes(), 2, "0")) +
        ":".concat(padLeft(d.getUTCSeconds(), 2, "0"), "+0000"));
}
exports.toISO8601Extended = toISO8601Extended;
/**
 * Converts an Object to an Array:
 * * Property names will be lost
 * * Values will not have a particular order
 */
function objectToArray(obj) {
    if (isObject(obj)) {
        var result = [];
        var keys = Object.keys(obj);
        var length_7 = keys.length;
        for (var i = 0; i < length_7; i++) {
            result.push(obj[keys[i]]);
        }
        return result;
    }
    return [];
}
exports.objectToArray = objectToArray;
/**
 * Create a constant string based on the given object
 * Objects with the same properties should result in the same string
 *
 * Warning: this function will result in an endless loop
 * when object has references to itself
 */
function objectToHash(obj) {
    if (typeof obj === "object") {
        if (obj === null)
            return "o" + obj;
        var result = "o";
        var keys = Object.keys(obj);
        // Sort keys for comparable results
        keys.sort();
        var length_8 = keys.length;
        for (var i = 0; i < length_8; i++) {
            var key = keys[i];
            result += "k" + key;
            var v = obj[key];
            switch (typeof v) {
                case "boolean":
                    result += "b" + v;
                    break;
                case "number":
                    result += "n" + v;
                    break;
                case "string":
                    result += "s" + v;
                    break;
                case "function":
                    result += "f" + v;
                    break;
                case "undefined":
                    result += "u" + v;
                    break;
                case "object":
                    result += objectToHash(v);
                    break;
                default:
                    result += "unknown";
                    break;
            }
        }
        return result;
    }
    return "";
}
exports.objectToHash = objectToHash;
function stringToInt(str, radix) {
    if (isNEString(str)) {
        var int = parseInt(str, isNumber(radix) ? radix : 10);
        return isNaN(int) ? 0 : int;
    }
    return 0;
}
exports.stringToInt = stringToInt;
/**
 * Convert a MAC hex string to a MAC address.
 * For example: 0123456789AB to 01:23:45:67:89:AB
 *
 * Warning: this function does not check for invalid hex characters
 */
function hexToMacAddress(hex, separator) {
    var result = "";
    if (isString(hex) && hex.length === 12) {
        var MAC_SEPARATOR = isString(separator) ? separator : ":";
        result += hex.charAt(0);
        result += hex.charAt(1);
        result += MAC_SEPARATOR;
        result += hex.charAt(2);
        result += hex.charAt(3);
        result += MAC_SEPARATOR;
        result += hex.charAt(4);
        result += hex.charAt(5);
        result += MAC_SEPARATOR;
        result += hex.charAt(6);
        result += hex.charAt(7);
        result += MAC_SEPARATOR;
        result += hex.charAt(8);
        result += hex.charAt(9);
        result += MAC_SEPARATOR;
        result += hex.charAt(10);
        result += hex.charAt(11);
    }
    return result;
}
exports.hexToMacAddress = hexToMacAddress;
/**
 * Converts polar coordinates to cartesian.
 * 0 degrees is at the right and going counter clock wise.
 */
function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees * Math.PI) / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians),
    };
}
exports.polarToCartesian = polarToCartesian;
/**
 * Returns 0 if num is invalid
 */
function clamp(num, min, max) {
    if (isVNumber(num) && isVNumber(min) && isVNumber(max)) {
        if (num < min)
            return min;
        if (num > max)
            return max;
        return num;
    }
    return 0;
}
exports.clamp = clamp;
/**
 * Returns 0 if angle is invalid
 */
function clampDegrees(angle) {
    if (isVNumber(angle)) {
        var ratio = Math.floor(angle / 360);
        return angle - ratio * 360;
    }
    return 0;
}
exports.clampDegrees = clampDegrees;
// #endregion
// #region Promises
var BasPromiseResult = /** @class */ (function () {
    function BasPromiseResult() {
        this.done = false;
        this.resolved = false;
        this.result = null;
    }
    return BasPromiseResult;
}());
exports.BasPromiseResult = BasPromiseResult;
/**
 * Check if all Promises are done
 */
function _areAllPromisesDone(promiseResults) {
    var length = promiseResults.length;
    for (var i = 0; i < length; i++) {
        // Check if Promise was finished
        if (!promiseResults[i].done)
            return false;
    }
    return true;
}
/**
 * Resolves as soon as at least one of the Promises resolves.
 * If no Promise resolves then this will reject with all rejections.
 */
function promiseAny(promises) {
    var length;
    if (Array.isArray(promises)) {
        length = promises.length;
        if (length === 0)
            return Promise.resolve(promises);
        return new Promise(resultPromiseConstructor);
    }
    return Promise.reject(new Error("Invalid input"));
    function resultPromiseConstructor(resolve, reject) {
        var promiseResult;
        var _finished = false;
        // Create array to hold all Promise states
        var promiseResults = [];
        // Iterate all Promises
        for (var i = 0; i < length; i++) {
            // Check if element is Promise
            if (typeof promises[i].then === "function") {
                promiseResult = new BasPromiseResult();
                promiseResults.push(promiseResult);
                promises[i].then(onPromiseDone.bind(null, promiseResult, true), onPromiseDone.bind(null, promiseResult, false));
            }
            else {
                // Create "finished" (rejected) BasPromiseResult
                promiseResult = new BasPromiseResult();
                promiseResult.done = true;
                promiseResult.resolved = false;
                promiseResult.result =
                    // eslint-disable-next-line @typescript-eslint/no-base-to-string
                    "Element is not a promise: " + promises[i];
                promiseResults.push(promiseResult);
            }
        }
        // Check if all Promises are done
        if (_areAllPromisesDone(promiseResults)) {
            // Execute reject
            // because all Promises are rejected
            _finish(true, promiseResults);
        }
        // Resolve when at least on Promise has resolved
        function onPromiseDone(promiseResult, resolved, result) {
            if (!promiseResult.done) {
                // Fill in result information
                promiseResult.done = true;
                promiseResult.resolved = resolved;
                promiseResult.result = result;
                // Check if Promise was resolved (not rejected)
                if (resolved) {
                    // Execute resolve
                    // because a Promise has resolved
                    _finish(false, result);
                }
                else {
                    // Check if all Promise are resolved
                    if (_areAllPromisesDone(promiseResults)) {
                        // Execute reject
                        // because all Promises are rejected
                        _finish(true, promiseResults);
                    }
                }
            }
            else {
                _finish(true, "Invalid state");
            }
        }
        function _finish(error, result) {
            if (!_finished) {
                _finished = true;
                if (error) {
                    reject(result);
                }
                else {
                    resolve(result);
                }
            }
        }
    }
}
exports.promiseAny = promiseAny;
/**
 * Resolves when all promises are done, including rejected promises
 */
function promiseAll(promises) {
    var length;
    if (Array.isArray(promises)) {
        length = promises.length;
        if (length === 0)
            return Promise.resolve(promises);
        return new Promise(resultPromiseConstructor);
    }
    return Promise.reject(new Error("Invalid input"));
    function resultPromiseConstructor(resolve, reject) {
        var promiseResult;
        var _finished = false;
        // Create array to hold all Promise states
        var promiseResults = [];
        // Iterate all Promises
        for (var i = 0; i < length; i++) {
            // Check if element is Promise
            if (typeof promises[i].then === "function") {
                // Create new BasPromiseResult which will hold Promise state
                promiseResult = new BasPromiseResult();
                promiseResults.push(promiseResult);
                // Handle Promise callbacks
                promises[i].then(onPromiseDone.bind(null, promiseResult, true), onPromiseDone.bind(null, promiseResult, false));
            }
            else {
                // Create "finished" (rejected) BasPromiseResult
                promiseResult = new BasPromiseResult();
                promiseResult.done = true;
                promiseResult.resolved = false;
                promiseResult.result =
                    // eslint-disable-next-line @typescript-eslint/no-base-to-string
                    "Element is not a promise: " + promises[i];
                promiseResults.push(promiseResult);
            }
        }
        // Check if all Promises are done
        if (_areAllPromisesDone(promiseResults)) {
            // Resolve with array of promise results
            _finish(false, promiseResults);
        }
        function onPromiseDone(promiseResult, resolved, result) {
            if (!promiseResult.done) {
                // Fill in result information
                promiseResult.done = true;
                promiseResult.resolved = resolved;
                promiseResult.result = result;
                // Check if all Promises are done
                if (_areAllPromisesDone(promiseResults)) {
                    // Resolve with array of promise results
                    _finish(false, promiseResults);
                }
            }
            else {
                _finish(true, "Invalid state");
            }
        }
        function _finish(error, result) {
            if (!_finished) {
                _finished = true;
                if (error) {
                    reject(result);
                }
                else {
                    resolve(result);
                }
            }
        }
    }
}
exports.promiseAll = promiseAll;
// #endregion
// #region Executes
function exec(fn) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (isFunction(fn))
        return fn.apply(null, args);
}
exports.exec = exec;
function execute(fn) {
    if (isFunction(fn))
        fn();
}
exports.execute = execute;
/**
 * Executes the given function on the given object.
 */
function executeFunction(obj, functionName) {
    if (isObject(obj) && isFunction(obj[functionName])) {
        // Using execute won't respect the this context of the function
        obj[functionName]();
    }
}
exports.executeFunction = executeFunction;
/**
 * Executes the function on each item/property
 */
function executeFunctionAll(obj, functionName) {
    if (Array.isArray(obj)) {
        var length_9 = obj.length;
        for (var i = 0; i < length_9; i++) {
            executeFunction(obj[i], functionName);
        }
    }
    else if (isObject(obj)) {
        var keys = Object.keys(obj);
        var length_10 = keys.length;
        for (var i = 0; i < length_10; i++) {
            executeFunction(obj[keys[i]], functionName);
        }
    }
}
exports.executeFunctionAll = executeFunctionAll;
/**
 * Executes all functions inside an array
 */
function executeArray(array) {
    if (Array.isArray(array)) {
        var length_11 = array.length;
        for (var i = 0; i < length_11; i += 1) {
            execute(array[i]);
        }
    }
}
exports.executeArray = executeArray;
// #endregion
// #region Object manipulation
/**
 * Iterates an object properties and looks for the given value.
 *
 * * Returns an array with the property names.
 * * Returns an empty array when no matches were found.
 */
function getKeys(obj, value) {
    // Create result array
    var result = [];
    // Check input
    if (isObject(obj)) {
        // Iterate object properties
        var keys = Object.keys(obj);
        var length_12 = keys.length;
        for (var i = 0; i < length_12; i++) {
            // Check for value
            if (obj[keys[i]] === value) {
                // Add key to results
                result.push(keys[i]);
            }
        }
    }
    return result;
}
exports.getKeys = getKeys;
/**
 * Sets 'value' for each key on given object.
 */
function setProperties(obj, keys, value) {
    // Check input
    if (isObject(obj) && Array.isArray(keys)) {
        // Iterate all keys
        var length_13 = keys.length;
        for (var i = 0; i < length_13; i++) {
            var key = keys[i];
            // Set value for key
            if (isString(key) || isNumber(key) || isBool(key))
                obj[key + ""] = value;
        }
    }
}
exports.setProperties = setProperties;
/**
 * Remove certain key(s) from an object.
 *
 * Returns a new object.
 */
function removeKeys(obj, keysToRemove) {
    if (isObject(obj) && Array.isArray(keysToRemove)) {
        var newObj = {};
        var keys = Object.keys(obj);
        var length_14 = keys.length;
        for (var i = 0; i < length_14; i++) {
            var key = keys[i];
            // Check key against "to remove" keys
            if (keysToRemove.indexOf(key) === -1) {
                // Copy property (shallow)
                newObj[key] = obj[key];
            }
        }
        return newObj;
    }
    return null;
}
exports.removeKeys = removeKeys;
/**
 * Keep certain key(s) on an object.
 *
 * Returns a new object.
 */
function keepKeys(obj, keysToKeep) {
    if (isObject(obj) && Array.isArray(keysToKeep)) {
        var newObj = {};
        var keys = Object.keys(obj);
        var length_15 = keys.length;
        for (var i = 0; i < length_15; i++) {
            var key = keys[i];
            // Check key against "to keep" keys
            if (keysToKeep.indexOf(key) > -1) {
                // Copy property (shallow)
                newObj[key] = obj[key];
            }
        }
        return newObj;
    }
    return null;
}
exports.keepKeys = keepKeys;
/**
 * Shallow copy an object.
 *
 * Returns a new object.
 */
function copyObjectShallow(obj) {
    if (isObject(obj)) {
        var newObj = {};
        var keys = Object.keys(obj);
        var length_16 = keys.length;
        for (var i = 0; i < length_16; i++) {
            newObj[keys[i]] = obj[keys[i]];
        }
        return newObj;
    }
    return null;
}
exports.copyObjectShallow = copyObjectShallow;
/**
 * Deep copy of an object.
 * Functions and symbols will be copied by reference (shallow).
 *
 * Returns a new object.
 *
 * Warning: this function will result in an endless loop
 * when object has references to itself
 */
function copyObject(obj) {
    if (Array.isArray(obj)) {
        var length_17 = obj.length;
        var result = new Array(length_17);
        for (var i = 0; i < length_17; i++) {
            var value = obj[i];
            result[i] = typeof value === "object" ? copyObject(value) : value;
        }
        return result;
    }
    else if (isObject(obj)) {
        var result = {};
        var keys = Object.keys(obj);
        var length_18 = keys.length;
        for (var i = 0; i < length_18; i++) {
            var key = keys[i];
            var value = obj[key];
            result[key] = typeof value === "object" ? copyObject(value) : value;
        }
        return result;
    }
    return null;
}
exports.copyObject = copyObject;
/**
 * Shallow merge object2 into object1.
 * If a property exists in both object, object2 will overwrite.
 * Returns object1
 */
function mergeObjects(object1, object2) {
    // Check input
    if (isObject(object1) && isObject(object2)) {
        // Iterate object2 properties
        var keys = Object.keys(object2);
        var length_19 = keys.length;
        for (var i = 0; i < length_19; i++) {
            object1[keys[i]] = object2[keys[i]];
        }
    }
    return isObject(object1) ? object1 : null;
}
exports.mergeObjects = mergeObjects;
/**
 * Merge partial into main.
 * If a property exists on both objects, partial will overwrite.
 * Properties that are an object will also be merged.
 * Returns main.
 *
 * Warning: this function will result in an endless loop
 * when object has references to itself
 */
function mergeObjectsDeep(main, partial) {
    if (isObject(main) && isObject(partial)) {
        var keys = Object.keys(partial);
        var length_20 = keys.length;
        for (var i = 0; i < length_20; i++) {
            var pKey = keys[i];
            var mValue = main[pKey];
            var pValue = partial[pKey];
            var mType = typeof mValue;
            var pType = typeof pValue;
            if (mType === pType && !Array.isArray(mValue) && !Array.isArray(pValue)) {
                if (mType === "object") {
                    mergeObjectsDeep(mValue, pValue);
                }
                else {
                    main[pKey] = partial[pKey];
                }
            }
            else {
                main[pKey] = pType === "object" ? copyObject(pValue) : partial[pKey];
            }
        }
    }
    return isObject(main) ? main : null;
}
exports.mergeObjectsDeep = mergeObjectsDeep;
/**
 * Merge object1 and object2 in a new object.
 * Object1 and object2 are not modified.
 * Only adds keys that have a number,
 * adds the numbers if both abjects have a number for the same key.
 */
function mergeCounterObjects(object1, object2) {
    if (isObject(object1) || isObject(object2)) {
        var result = {};
        if (isObject(object1)) {
            var keys = Object.keys(object1);
            var length_21 = keys.length;
            for (var i = 0; i < length_21; i++) {
                if (isPNumber(object1[keys[i]], true)) {
                    result[keys[i]] = object1[keys[i]];
                }
            }
        }
        if (isObject(object2)) {
            var keys = Object.keys(object2);
            var length_22 = keys.length;
            for (var i = 0; i < length_22; i++) {
                if (isPNumber(object2[keys[i]], true)) {
                    if (isPNumber(result[keys[i]])) {
                        result[keys[i]] += object2[keys[i]];
                    }
                    else {
                        result[keys[i]] = object2[keys[i]];
                    }
                }
            }
        }
        return result;
    }
    return null;
}
exports.mergeCounterObjects = mergeCounterObjects;
/**
 * Switches the key values pairs, key becomes value, value becomes key.
 *
 * This means that all keys and values become strings and
 * duplicate values (and their keys) will be lost.
 *
 * Warning
 * Functions that become keys are literal (including comments, whitespace, ...)
 */
function switchObjectKeyValue(obj) {
    if (isObject(obj)) {
        var result = {};
        var keys = Object.keys(obj);
        var length_23 = keys.length;
        for (var i = 0; i < length_23; i++) {
            result[obj[keys[i]]] = keys[i];
        }
        return result;
    }
    return null;
}
exports.switchObjectKeyValue = switchObjectKeyValue;
// #endregion
/**
 * Pad input to target length with "padElement" or "0"
 */
function padLeft(input, target, padElement) {
    if (isString(input) || isVNumber(input)) {
        var _input = "" + input;
        if (isPNumber(target)) {
            var _padElement = isNEString(padElement) ? padElement : "0";
            var length_24 = _input.length;
            var diff = target - length_24;
            if (diff > 0) {
                var padding = "";
                for (var i = 0; i < diff; i++)
                    padding += _padElement;
                return padding + _input;
            }
        }
        return _input;
    }
    return "";
}
exports.padLeft = padLeft;
/**
 * Format temperature based on temperature fraction
 * Supported precisions: .1, .5, 1
 */
function formatTemperature(temp, _c) {
    var _d = _c === void 0 ? {} : _c, _e = _d.precision, precision = _e === void 0 ? 0.5 : _e, _f = _d.includeTrailingZeros, includeTrailingZeros = _f === void 0 ? false : _f;
    var firstDigitAfterComma = getTemperatureFraction(temp, precision);
    return firstDigitAfterComma !== 0
        ? Math.floor(temp) + "." + firstDigitAfterComma
        : "" +
            Math.round(temp) +
            (includeTrailingZeros ? "." + firstDigitAfterComma : "");
}
exports.formatTemperature = formatTemperature;
/**
 * Returns fraction based on temperature precision
 * Supported precisions: .1, .5, 1
 *
 * For example:
 * Temperature is 20.6
 *
 * If precision is 0.1 it will return 6
 * If precision is 0.5 it will return 5
 * If precision is 1 it will return an empty string
 */
function getTemperatureFraction(temp, precisionParam) {
    if (precisionParam === void 0) { precisionParam = 0.5; }
    var roundedTemp = Math.round(temp * 10) / 10;
    var firstDigitAfterComma = Number(roundedTemp.toFixed(1).slice(-1));
    var result = roundedTemp / precisionParam;
    var roundedResult = Math.round(result * 10) / 10;
    return roundedResult % 1 === 0
        ? firstDigitAfterComma !== 0
            ? firstDigitAfterComma
            : 0
        : precisionParam % 1 !== 0
            ? firstDigitAfterComma / 10 >= 0.25 && firstDigitAfterComma / 10 < 0.75
                ? precisionParam * 10
                : 0
            : 0;
}
exports.getTemperatureFraction = getTemperatureFraction;
/**
 * Corrects the desired value according to given constraints.
 * This function does not check:
 *  if a step value exists between min and max.
 *  if min and max are a multiple of the step.
 */
function getCorrectedValue(desiredValue, constraints) {
    var corrected = desiredValue;
    if (isObject(constraints)) {
        var _min = isNumber(constraints.min) && isVNumber(constraints.min)
            ? constraints.min
            : undefined;
        var _max = isNumber(constraints.max) && isVNumber(constraints.max)
            ? constraints.max
            : undefined;
        var _step = isNumber(constraints.step) && isPNumber(constraints.step)
            ? constraints.step
            : undefined;
        if (_checkLimits(_min, _max))
            return corrected;
        if (isNumber(_step)) {
            var rest = corrected - Math.floor(corrected / _step) * _step;
            if (rest) {
                var lowMatch = corrected - rest;
                var highMatch = lowMatch + _step;
                if (corrected - lowMatch > highMatch - corrected) {
                    corrected = highMatch;
                }
                else {
                    corrected = lowMatch;
                }
                _checkLimits(_min, _max);
            }
        }
    }
    return corrected;
    function _checkLimits(min, max) {
        if (isNumber(min) && corrected < min) {
            corrected = min;
            return true;
        }
        if (isNumber(max) && corrected > max) {
            corrected = max;
            return true;
        }
        return false;
    }
}
exports.getCorrectedValue = getCorrectedValue;
function compareRoundedValue(value1, value2) {
    return Math.round(value1) === Math.round(value2);
}
exports.compareRoundedValue = compareRoundedValue;
/**
 * returns function with captured destructor
 */
function setEventListener(emitter, event, listener) {
    if (isObject(emitter)) {
        // Register event listener
        emitter.on(event, listener);
        // Return the reference to the removeListener function
        return function () {
            emitter.removeListener(event, listener);
        };
    }
    return null;
}
exports.setEventListener = setEventListener;
/**
 * returns function with captured destructor
 */
function setDOMListener(emitter, event, listener, options) {
    if (isObject(emitter)) {
        // Register event listener
        emitter.addEventListener(event, listener, options);
        // Return the reference to the removeEventListener function
        return function () {
            emitter.removeEventListener(event, listener, options);
        };
    }
    return null;
}
exports.setDOMListener = setDOMListener;
/**
 * Parse string as integer, return 0 on failure
 */
function parseInteger(str, radix) {
    if (isNEString(str)) {
        var int = parseInt(str, isNumber(radix) ? radix : 10);
        if (isNaN(int))
            return 0;
        return int;
    }
    return 0;
}
exports.parseInteger = parseInteger;
function parseIso8601(str) {
    var result = {
        year: 0,
        month: 0,
        day: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        timezoneOffsetHours: 0,
        timezoneOffsetMinutes: 0,
        rawTimezoneOffset: "",
    };
    if (isString(str)) {
        var trimmed = str.trim();
        var length_25 = trimmed.length;
        var isUTC = trimmed.charAt(length_25 - 1) === "Z";
        var d = isUTC ? trimmed.substring(0, length_25 - 1) : trimmed;
        var idxT = d.indexOf("T");
        var idxPlus = isUTC ? -1 : d.indexOf("+");
        var idxMinus = isUTC ? -1 : idxT > -1 ? d.indexOf("-", idxT) : -1;
        var offsetIdx = isUTC
            ? -1
            : idxPlus > -1
                ? idxPlus
                : idxMinus > -1
                    ? idxMinus
                    : -1;
        var t = offsetIdx > -1 ? d.substring(0, offsetIdx) : d;
        result.rawTimezoneOffset = isUTC
            ? "Z"
            : offsetIdx > -1
                ? d.substring(offsetIdx)
                : "";
        // TODO Further parse timezone offset hours and minutes
        var s1 = t.split("T");
        var s2 = s1[0].split("-");
        result.year = _parseIso8601Part(s2[0], 0);
        result.month = _parseIso8601Part(s2[1], 0);
        result.day = _parseIso8601Part(s2[2], 0);
        if (isString(s1[1])) {
            var s3 = s1[1].split(":");
            result.hours = _parseIso8601Part(s3[0], 0);
            result.minutes = _parseIso8601Part(s3[1], 0);
            result.seconds = _parseIso8601Part(s3[2], 0);
        }
    }
    return result;
}
exports.parseIso8601 = parseIso8601;
function _parseIso8601Part(input, defaultValue) {
    if (isString(input)) {
        var num = parseInt(input, 10);
        return isVNumber(num) ? num : defaultValue;
    }
    return defaultValue;
}
function stripTimezoneFromIso8601(input) {
    if (isString(input)) {
        var length_26 = input.length;
        var isUTC = input.charAt(length_26 - 1) === "Z";
        var d = isUTC ? input.substring(0, length_26 - 1) : input;
        var idxT = d.indexOf("T");
        var idxPlus = isUTC ? -1 : d.indexOf("+");
        var idxMinus = isUTC ? -1 : idxT > -1 ? d.indexOf("-", idxT) : -1;
        var offsetIdx = isUTC
            ? -1
            : idxPlus > -1
                ? idxPlus
                : idxMinus > -1
                    ? idxMinus
                    : -1;
        return offsetIdx > -1 ? d.substring(0, offsetIdx) : d;
    }
    return "";
}
exports.stripTimezoneFromIso8601 = stripTimezoneFromIso8601;
/**
 * Returns the distance between 2 points squared
 */
function distanceSquared(x1, y1, x2, y2) {
    return (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
}
exports.distanceSquared = distanceSquared;
function timeout(timeout) {
    return isPNumber(timeout)
        ? new Promise(_timeoutPromise)
        : Promise.reject(new Error("Invalid Parameters"));
    function _timeoutPromise(resolve) {
        setTimeout(resolve, timeout);
    }
}
exports.timeout = timeout;
/**
 * Match is case-sensitive
 */
function startsWith(str, starts) {
    if (isString(str) && isString(starts)) {
        return str.slice(0, starts.length) === starts;
    }
    return false;
}
exports.startsWith = startsWith;
/**
 * Match is case-sensitive
 */
function endsWith(str, ends) {
    if (isString(str) && isString(ends)) {
        var length_27 = str.length;
        return str.slice(length_27 - ends.length, length_27) === ends;
    }
    return false;
}
exports.endsWith = endsWith;
/**
 * Adds "add" to "str" with the default separator " - "
 * or the supplied separator.
 * Only adds if the "add" is not empty.
 */
function addToString(str, add, separator) {
    if (isString(str)) {
        if (isNEString(add)) {
            return str.length > 0
                ? str + (isString(separator) ? separator : " - ") + add
                : str + add;
        }
        return str;
    }
    return "";
}
exports.addToString = addToString;
/**
 * Strip from the start of the input string
 *
 * * When strip is a string,
 * check if str starts with the value of strip and remove it
 * * When strip is a number,
 * remove strip characters from the start of the string
 */
function stripStart(str, strip) {
    if (!isString(str))
        return "";
    if (isString(strip)) {
        var length_28 = strip.length;
        if (str.slice(0, length_28) === strip) {
            return str.substring(length_28);
        }
    }
    else if (isPNumber(strip)) {
        return str.substring(strip);
    }
    return str;
}
exports.stripStart = stripStart;
/**
 * Searches for characters (case-sensitive)
 * from `charsToCheck` string in `str` string.
 * Returns string with found characters.
 */
function searchCharacters(str, charsToCheck) {
    if (isNEString(str) && isNEString(charsToCheck)) {
        var result = "";
        var length_29 = charsToCheck.length;
        for (var i = 0; i < length_29; i++) {
            var char = charsToCheck.charAt(i);
            if (str.indexOf(char) >= 0)
                result += char;
        }
        return result;
    }
    return "";
}
exports.searchCharacters = searchCharacters;
/**
 * Generates a random string with the specified length
 */
function randomString(length) {
    var result = "";
    for (var i = 0; i < length; i++) {
        result += ENTRIES[Math.floor(Math.random() * ENTRIES_LENGTH)];
    }
    return result;
}
exports.randomString = randomString;
/**
 * Checks if a given value is within a certain amount of play of another given
 * value. The bounds loop around, e.g. when set to -180 and 180 with a maxPlay
 * value of 30 and a targetValue of 170, a checkValue of -165 will return true
 * */
function isWithinLoopingBounds(checkValue, targetValue, minBound, maxBound, maxPlay) {
    var min = targetValue - maxPlay;
    var max = targetValue + maxPlay;
    var size = maxBound - minBound;
    if (min < minBound)
        min += size;
    if (max > maxBound)
        max -= size;
    return min < max
        ? checkValue > min && checkValue < max
        : checkValue > min || checkValue < max;
}
exports.isWithinLoopingBounds = isWithinLoopingBounds;
/**
 * Round a number to given increment (with initial offset)
 *
 * Important, this can still result in unexpected values
 * because of JavaScript rounding.
 * For example: 0.345 round to 0.1 results in
 * 0.30000000000000004
 */
function round(value, increment, offset) {
    if (isVNumber(value)) {
        if (isPNumber(increment)) {
            var _offset = isNumber(offset) && isFinite(offset) ? offset : 0;
            return Math.round((value - _offset) / increment) * increment + _offset;
        }
        return value;
    }
    return NaN;
}
exports.round = round;
/**
 * Works like toFixed but trims padded "0"
 */
function toFixedRounded(input, precision) {
    return trimNumber(input.toFixed(precision));
}
exports.toFixedRounded = toFixedRounded;
/**
 * "trims" number string representations from padded "0"
 */
function trimNumber(input, onlyLeft) {
    var str = isNumber(input) ? "" + input : input;
    if (!isString(str))
        return "";
    var trimmed = str.trim();
    // Check left for padded "0"
    var leftLength = trimmed.length;
    var first = trimmed.charAt(0);
    var hasSign = first === "-" || first === "+";
    var numStartIdx = hasSign ? 1 : 0;
    var i, char;
    // Find first left non-0 character (excluding sign)
    for (i = numStartIdx; i < leftLength; i++) {
        char = trimmed.charAt(i);
        if (char !== "0")
            break;
    }
    // Set last valid char index
    i = charIsNumber(char) && char !== "0" ? i : i > numStartIdx ? i - 1 : i;
    var leftCorrected = i === numStartIdx
        ? trimmed
        : hasSign
            ? "".concat(first).concat(trimmed.substring(i))
            : trimmed.substring(i);
    if (onlyLeft !== true) {
        // Check right for padded "0"
        var idx = leftCorrected.indexOf(".");
        if (idx > -1) {
            var rightLength = leftCorrected.length;
            // Find first right non-0 character
            for (i = rightLength - 1; i >= idx; i--) {
                if (leftCorrected.charAt(i) !== "0")
                    break;
            }
            return leftCorrected.substring(0, i === idx ? idx : ++i);
        }
    }
    return leftCorrected;
}
exports.trimNumber = trimNumber;
function charIsNumber(char) {
    return (char === "0" ||
        char === "1" ||
        char === "2" ||
        char === "3" ||
        char === "4" ||
        char === "5" ||
        char === "6" ||
        char === "7" ||
        char === "8" ||
        char === "9");
}
exports.charIsNumber = charIsNumber;
/**
 * Convert exponentional number string to a fixed length
 */
function eNumberToFixedLength(input, maxLength) {
    var eIdx = input.indexOf("e");
    if (eIdx > -1) {
        var length_30 = input.length;
        var eStr = input.substring(eIdx);
        var eLength = eStr.length;
        var isNegative = input.charAt(0) === "-";
        // '-' sign + e+xxx or e-xxx length
        var constLength = isNegative ? 1 + eLength : eLength;
        var numbersLength = length_30 - constLength;
        var desiredNumbersLength = maxLength - constLength;
        var targetNumbersLength = desiredNumbersLength < 1
            ? // Force 1, otherwise no valid number kan be displayed
                1
            : desiredNumbersLength === 2
                ? // Force 1, otherwise X.e+XXX is not valid '.' followed by 'e'
                    1
                : desiredNumbersLength;
        var finalNumbersLength = Math.min(targetNumbersLength, numbersLength);
        var endIdx = finalNumbersLength + (isNegative ? 1 : 0);
        var numStr = input.substring(0, endIdx);
        return "".concat(trimNumber(numStr)).concat(eStr);
    }
    return input;
}
exports.eNumberToFixedLength = eNumberToFixedLength;
function numberToString(input, maxLength) {
    if (!isNumber(input) || !isNumber(maxLength))
        return "";
    var str = "" + input;
    var length = str.length;
    var lengthDiff = length - maxLength;
    if (lengthDiff > 0) {
        if (str.indexOf("e") > -1)
            return eNumberToFixedLength(str, maxLength);
        var dotIdx = str.indexOf(".");
        if (dotIdx > -1) {
            var fracStr = str.substring(dotIdx);
            var fracLength = fracStr.length;
            var fracDiff = lengthDiff - fracLength;
            if (fracDiff === 0 || fracDiff === -1) {
                // Round to remove fractional part
                return "" + Math.round(input);
            }
            else if (fracDiff > 0) {
                // Removing fractional part is not enough
                return eNumberToFixedLength(input.toExponential(), maxLength);
            }
            else {
                // Trim fractional part
                return toFixedRounded(input, Math.abs(fracDiff) - 1);
            }
        }
        else {
            return eNumberToFixedLength(input.toExponential(), maxLength);
        }
    }
    return str;
}
exports.numberToString = numberToString;
/**
 * Returns the number of meaningful fractional digits
 */
function getPrecision(value) {
    if (!isVNumber(value))
        return 0;
    var str = value.toString();
    var idxD = str.indexOf(".");
    var hasDot = idxD > -1;
    var idxE = str.indexOf("e");
    if (idxE > -1) {
        var expStr = str.substring(idxE);
        var exp = parseInt(expStr);
        if (hasDot) {
            var fractionalLength = str.substring(idxD + 1, idxE).length;
            if (exp > 0) {
                return fractionalLength > exp ? fractionalLength - exp : 0;
            }
            else {
                return fractionalLength + Math.abs(exp);
            }
        }
        else {
            if (exp > 0)
                return 0;
            return Math.abs(exp);
        }
    }
    else {
        if (hasDot) {
            return str.substring(idxD + 1).length;
        }
    }
    return 0;
}
exports.getPrecision = getPrecision;
/**
 * Checks whether the URI is a "complete" URI/URL.
 * This means checking whether a scheme is present.
 * Only tests for schemes: data:, http:, https:, ftp:, file:
 */
function hasValidKnownScheme(uri) {
    if (!isString(uri))
        return false;
    var c1 = uri.charAt(0);
    var c2 = uri.charAt(1);
    var c3 = uri.charAt(2);
    var c4 = uri.charAt(3);
    var c5 = uri.charAt(4);
    var c6 = uri.charAt(5);
    // https
    // http
    if (c1 === "h" && c2 === "t" && c3 === "t" && c4 === "p") {
        if (c5 === "s" && c6 === ":")
            return true;
        if (c5 === ":")
            return true;
    }
    // data
    if (c1 === "d" && c2 === "a" && c3 === "t" && c4 === "a" && c5 === ":") {
        return true;
    }
    // file
    if (c1 === "f" && c2 === "i" && c3 === "l" && c4 === "e" && c5 === ":") {
        return true;
    }
    // ftp
    return c1 === "f" && c2 === "t" && c3 === "p" && c4 === ":";
}
exports.hasValidKnownScheme = hasValidKnownScheme;
// Based on https://blog.stevenlevithan.com/archives/date-time-format
function dateFormat(date, mask, utc) {
    if (!isNEString(mask))
        return "";
    var _date = isObject(date)
        ? date
        : isUndefined(date) || date === null
            ? new Date()
            : isVNumber(date)
                ? new Date(date)
                : new Date();
    if (!(_date instanceof Date))
        return "";
    var d = function () { return (utc === true ? _date.getUTCDate() : _date.getDate()); };
    var D = function () { return (utc === true ? _date.getUTCDay() : _date.getDay()); };
    var m = function () {
        return utc === true ? _date.getUTCMonth() : _date.getMonth();
    };
    var y = function () {
        return utc === true ? _date.getUTCFullYear() : _date.getFullYear();
    };
    var H = function () {
        return utc === true ? _date.getUTCHours() : _date.getHours();
    };
    var M = function () {
        return utc === true ? _date.getUTCMinutes() : _date.getMinutes();
    };
    var s = function () {
        return utc === true ? _date.getUTCSeconds() : _date.getSeconds();
    };
    var L = function () {
        return utc === true ? _date.getUTCMilliseconds() : _date.getMilliseconds();
    };
    var o = function () { return (utc === true ? 0 : _date.getTimezoneOffset()); };
    var W = function () { return getWeekNumber(_date); };
    var flags = {
        d: function () { return d(); },
        dd: function () { return padLeft(d(), 2); },
        ddd: function () { return DATE_FORMAT_DAY_NAMES[D()]; },
        dddd: function () { return DATE_FORMAT_DAY_NAMES[D() + 7]; },
        m: function () { return m() + 1; },
        mm: function () { return padLeft(m() + 1, 2); },
        mmm: function () { return DATE_FORMAT_MONTH_NAMES[m()]; },
        mmmm: function () { return DATE_FORMAT_MONTH_NAMES[m() + 12]; },
        yy: function () { return String(y()).slice(2); },
        yyyy: function () { return padLeft(y(), 4); },
        h: function () { return H() % 12 || 12; },
        hh: function () { return padLeft(H() % 12 || 12, 2); },
        H: function () { return H(); },
        HH: function () { return padLeft(H(), 2); },
        M: function () { return M(); },
        MM: function () { return padLeft(M(), 2); },
        s: function () { return s(); },
        ss: function () { return padLeft(s(), 2); },
        l: function () { return padLeft(L(), 3); },
        L: function () { return padLeft(Math.floor(L() / 10), 2); },
        t: function () { return (H() < 12 ? DATE_FORMAT_TIME_NAMES[0] : DATE_FORMAT_TIME_NAMES[1]); },
        tt: function () {
            return H() < 12 ? DATE_FORMAT_TIME_NAMES[2] : DATE_FORMAT_TIME_NAMES[3];
        },
        T: function () { return (H() < 12 ? DATE_FORMAT_TIME_NAMES[4] : DATE_FORMAT_TIME_NAMES[5]); },
        TT: function () {
            return H() < 12 ? DATE_FORMAT_TIME_NAMES[6] : DATE_FORMAT_TIME_NAMES[7];
        },
        Z: function () {
            var _c, _d;
            return utc === true
                ? "UTC"
                : ((_d = ((_c = _date.toString().match(DATE_FORMAT_TIMEZONE_REGEX)) !== null && _c !== void 0 ? _c : [""]).pop()) !== null && _d !== void 0 ? _d : "").replace(DATE_FORMAT_TIMEZONE_CLIP_REGEX, "");
        },
        o: function () {
            return (o() > 0 ? "-" : "+") +
                padLeft(Math.floor(Math.abs(o()) / 60) * 100 + (Math.abs(o()) % 60), 4);
        },
        p: function () {
            return (o() > 0 ? "-" : "+") +
                padLeft(Math.floor(Math.abs(o()) / 60), 2) +
                ":" +
                padLeft(Math.floor(Math.abs(o()) % 60), 2);
        },
        S: function () {
            return ["th", "st", "nd", "rd"][d() % 10 > 3
                ? 0
                : (((d() % 100) - (d() % 10) !== 10 ? 1 : 0) * d()) % 10];
        },
        W: function () { return W(); },
        WW: function () { return padLeft(W(), 2); },
    };
    return mask.replace(DATE_FORMAT_TOKEN_REGEX, function (match) {
        return match in flags ? "" + flags[match]() : match.slice(1, match.length - 1);
    });
}
exports.dateFormat = dateFormat;
// Based on https://stackoverflow.com/questions/9045868
function getWeekNumber(date) {
    var d = date !== null && date !== void 0 ? date : new Date();
    // day 0 is monday
    var day = (d.getDay() + 6) % 7;
    // get thursday of present week
    var thursday = new Date(d.getTime());
    thursday.setDate(d.getDate() - day + 3);
    // set 1st january first
    var firstThursday = new Date(thursday.getFullYear(), 0, 1);
    // if Jan 1st is not a thursday...
    if (firstThursday.getDay() !== 4) {
        firstThursday.setMonth(0, 1 + ((11 /* 4 + 7 */ - firstThursday.getDay()) % 7));
    }
    return (1 +
        Math.floor((thursday.getTime() -
            firstThursday.getTime() +
            (firstThursday.getTimezoneOffset() - thursday.getTimezoneOffset()) *
                60000) / // = 60 * 1000 = 1 minute in ms
            604800000 // = 7 * 24 * 60 * 60 * 1000 = 7 days in ms
        ));
}
exports.getWeekNumber = getWeekNumber;
/**
 * Generate uuidv4
 * Do not pass in any parameters
 */
function uuidv4(a, b) {
    for (b = a = ""; a++ < 36; b +=
        (a * 51) & 52
            ? (a ^ 15 ? 8 ^ (Math.random() * (a ^ 20 ? 16 : 4)) : 4).toString(16)
            : "-")
        ;
    return b;
}
exports.uuidv4 = uuidv4;
/**
 * Array.filter polyfill
 */
function filter(array, predicate) {
    if (Array.isArray(array)) {
        var filteredArr = [];
        var length_31 = array.length;
        for (var i = 0; i < length_31; i++) {
            var value = array[i];
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (exec(predicate, value))
                filteredArr.push(value);
        }
        return filteredArr;
    }
    return null;
}
exports.filter = filter;
/**
 * Removes all occurrences of "item" in the given "array".
 * The given "array" is modified and returned
 */
function removeFromArray(array, item) {
    if (Array.isArray(array)) {
        var idx = array.indexOf(item);
        while (idx > -1) {
            array.splice(idx, 1);
            idx = array.indexOf(item);
        }
    }
    return array;
}
exports.removeFromArray = removeFromArray;
var BasVersion = /** @class */ (function () {
    function BasVersion(version) {
        this.major = 0;
        this.minor = 0;
        this.patch = 0;
        this.build = 0;
        this.text = "";
        this.textShort = "";
        this.textFull = "";
        if (!isNEString(version) && !isVNumber(version))
            return;
        this.text = isNumber(version) ? "".concat(version) : version;
        var firstChar = this.text.charAt(0).toLowerCase();
        this.text =
            firstChar === "v" || firstChar === "="
                ? this.text.substring(1)
                : this.text;
        var split = this.text.split(".");
        var length = split.length;
        this.major = stringToInt(split[0]);
        if (length > 1)
            this.minor = stringToInt(split[1]);
        if (length > 2)
            this.patch = stringToInt(split[2]);
        if (length > 3)
            this.build = stringToInt(split[3]);
        var splitUnder = this.text.split("-");
        var splitPlus = this.text.split("+");
        var splitUnderLength = splitUnder.length;
        var splitPlusLength = splitPlus.length;
        if (splitUnderLength > 1 && splitPlusLength > 1) {
            // Ignore this case
        }
        else if (splitUnderLength === 2 && length < 4) {
            this.build = stringToInt(splitUnder[1]);
        }
        else if (splitPlusLength === 2 && length < 4) {
            this.build = stringToInt(splitPlus[1]);
        }
        else {
            // Ignore
        }
        this.textShort = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch);
        this.textFull = "".concat(this.textShort, ".").concat(this.build);
    }
    BasVersion.isSame = function (a, b) {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (a && b && isString(a.text) && isString(b.text)) {
            return a.text === b.text;
        }
        return false;
    };
    /**
     * Compare 2 BasVersion instances
     *
     * @example
     * BasVersion.compare(v1, v2)
     * // +1 : v1 > v2
     * //  0 : v1 = v2
     * // -1 : v1 < v2
     */
    BasVersion.compare = function (a, b) {
        var _a = isString(a) || isNumber(a)
            ? new BasVersion(a)
            : // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                a && isNumber(a.major)
                    ? a
                    : null;
        var _b = isString(b) || isNumber(b)
            ? new BasVersion(b)
            : // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                b && isNumber(b.major)
                    ? b
                    : null;
        if (_a && _b) {
            if (_a.major !== _b.major)
                return _a.major > _b.major ? 1 : -1;
            if (_a.minor !== _b.minor)
                return _a.minor > _b.minor ? 1 : -1;
            if (_a.patch !== _b.patch)
                return _a.patch > _b.patch ? 1 : -1;
            if (_a.build !== _b.build)
                return _a.build > _b.build ? 1 : -1;
        }
        else if (_a) {
            return 1;
        }
        else if (_b) {
            return -1;
        }
        return 0;
    };
    BasVersion.prototype.isSame = function (version) {
        return isString(version)
            ? this.text === version
            : BasVersion.isSame(this, version);
    };
    BasVersion.prototype.compare = function (version) {
        return BasVersion.compare(this, version);
    };
    return BasVersion;
}());
exports.BasVersion = BasVersion;
